import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BootstrapVue3 from "bootstrap-vue-3";
import Toast, { useToast } from "vue-toastification";
import store from "@/store"
import 'es6-promise/auto'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "vue-toastification/dist/index.css";
import '@fortawesome/fontawesome-free/css/all.min.css'
import "./components/main.css";

library.add(fas);
library.add(fab);

const toastOptions = {
  position: "top-center",
  timeout: 3962,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

const app = createApp(App);

// REGISTRAR EN ESTE ORDEN
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(store);
app.use(router);
app.use(BootstrapVue3);
app.use(Toast, toastOptions);

app.config.globalProperties.$toast = app.config.globalProperties.$toast || useToast();
app.mount("#app");